module.exports = __webpack_public_path__ + "img/konut-sigortasi.43efa6d4.svg";